import React, { Component } from 'react';
import { createComponent as cc } from 'react-fela';
import { inject, observer } from 'mobx-react';
import Grid from '@material-ui/core/Grid';
import { CircularProgress } from '@material-ui/core';
import { Switch, Route } from 'react-router-dom';
import DashBoardSidebar from '../../components/home/DashBoardSidebar';
import DashBoardHeader from '../../components/home/DashBoardHeader';
import FeedbackList from './feedbackList/FeedbackList';
import UsersList from './usersList/UsersList';
import UserDetail from './userDetail/UserDetail';
import GridWrapper from '../../components/wrappers/GridWrapper';
import GridWrapper100 from '../../components/wrappers/GridWrapper100';

const Wrapper = cc(() => ({
  height: '100vh',
  width: '100%',
}));

@inject('store')
@observer
export default class Home extends Component {
  constructor(props) {
    super(props);
    this.dashBoardStore = props.store.dashBoardStore;
    this.feedBotStore = props.store.feedBotStore;

    this.props.history.listen(() => {
      this.dashBoardStore.resetSearchString();
    });
  }

  componentDidMount = () => {
    this.feedBotStore.initFeedBotStore();
  };

  renderStoreloadingAnimation = () => (
    <GridWrapper100 container justify="space-around" alignItems="center">
      <Grid item xs={1}>
        <CircularProgress size={68} />
      </Grid>
    </GridWrapper100>
  );

  renderHomeRouter = (feedbackList, userList) => (
    <Switch>
      <Route
        exact
        path="/"
        render={props => (
          <GridWrapper>
            <FeedbackList feedbackList={feedbackList} {...props} />
          </GridWrapper>
        )}
      />

      <Route
        exact
        path="/users"
        render={() => <UsersList userList={userList} />}
      />
      <Route path="/users/:userId" component={UserDetail} />
    </Switch>
  );

  render() {
    const feedbackList = this.feedBotStore.feedbackList(this.dashBoardStore.searchString);
    const userList = this.feedBotStore.userList(this.dashBoardStore.searchString);
    const { feedBotStoreInitialized } = this.feedBotStore;

    return (
      <Wrapper>
        <DashBoardSidebar />
        <DashBoardHeader />

        {!feedBotStoreInitialized
          ? this.renderStoreloadingAnimation()
          : this.renderHomeRouter(feedbackList, userList)}
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/home/index.js